// extracted by mini-css-extract-plugin
export default {"headerModal":"DeleteWFModal_headerModal__kf66-","bodyModal":"DeleteWFModal_bodyModal__jiX6H"};